popup = document.getElementById('popup');
if(popup != null){
    var span = document.getElementsByClassName("close")[0];

    span.onclick = function() {
        popup.style.display = "none";
    }

    window.onclick = function(event) {
        if (event.target == popup) {
            popup.style.display = "none";
        }
    }
}